import FireDisabled from '@/_application/icons/fire-disabled';
import cn from 'classnames';
import Fire from '../../../icons/fire';
import {FlashSaleProductData} from '__generated__/__types__';
import {getRemainingQuantity} from '@/_application/modules/flash-sales/helper/flash-sale';

interface IProgressProps {
    className?: string;
    flashSaleData: FlashSaleProductData;
}

const FlashSaleProgress = ({className, flashSaleData}: IProgressProps) => {
    const isStarted = new Date().getTime() > new Date(flashSaleData?.date_from!).getTime();

    const calculateProgress = () => {
        const saleQty = flashSaleData?.sale_qty ?? 0;
        const dealQty = flashSaleData?.deal_qty ?? 1;

        const rawProgress = (saleQty / dealQty) * 100;

        let progress;

        if (rawProgress === 100) {
            progress = 90;
        } else if (rawProgress >= 87) {
            progress = 87;
        } else {
            progress = rawProgress;
        }

        return progress;
    };

    const remainingQuantity = getRemainingQuantity(flashSaleData);

    const renderUnActiveState = () => (
        <div className={cn('relative', className)}>
            <div className="h-2.5 w-full rounded-full bg-KPZ_Gray_05">
                <div
                    className="h-2.5 rounded-full border-2 border-solid border-gray-200 bg-KPZ_Gray-02"
                    style={{width: '0%'}}></div>
            </div>
            <div className="absolute -top-2 rounded-[10px] bg-KPZ_Gray-02 p-1" style={{left: 0}}>
                <FireDisabled width={16} height={16} />
            </div>
            <p className="mt-2 text-xs text-KPZ_text_2nd md:text-xs">Chưa bắt đầu</p>
        </div>
    );

    const renderActiveState = () => (
        <div className={cn('relative', className)}>
            <div className="h-2.5 w-full rounded-full bg-KPZ_Gray_05">
                <div
                    className="h-2.5 rounded-full border-2 border-solid border-gray-200 bg-amber-400"
                    style={{width: `${calculateProgress()}%`}}></div>
            </div>
            <div
                className="absolute -top-2 rounded-[10px] bg-amber-400 p-1"
                style={{left: `calc(${calculateProgress()}% - 3px)`}}>
                <Fire width={16} height={16} />
            </div>
            <p className="mt-2 text-xs text-KPZ_text_2nd md:text-xs">
                {remainingQuantity > 0 ? `Còn ${remainingQuantity} sản phẩm` : 'Cháy hàng'}
            </p>
        </div>
    );

    return !isStarted ? renderUnActiveState() : renderActiveState();
};

export default FlashSaleProgress;
